import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NB_AUTH_TOKEN_WRAPPER_TOKEN, NbAuthService } from '@nebular/auth';
import { ZAuthService } from './services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(protected authService: ZAuthService, private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // return true;
        return this.authService.isAuthenticated().map(isAuthenticated => {
            if (isAuthenticated) {
                return true;
            } else {
                this.router.navigate(['/auth/login']);
                return false;
            }
        }).catch(() => {
            this.router.navigate(['/auth/login']);
            return Observable.of(false);
        });
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot)
        : boolean | Observable<boolean> | Promise<boolean> {
        // return true;
        if (childRoute.component) {

            let guard: Function = (user) => this.authService.isUserAdmin(user);

            //TODO: move it closer to component itself
            if (childRoute.routeConfig.component.name === 'SuppliersBarcodesComponent') {
                guard = (user) => this.authService.isUserAdmin(user) || user.companyId > 0;
            } else if (childRoute.routeConfig.component.name === 'DashboardComponent') {
                guard = (user) => this.authService.isAuthenticated();
            }

            if (guard == null) {
                return true;
            }

            return this.authService.getCurrentUser().map(user => {
                if (guard(user)) {
                    return true;
                } else {
                    this.router.navigate(['/auth/login'], {queryParams: { type: 'denied' }});
                    return false;
                }
            }).catch(() => {
                this.router.navigate(['/auth/login'], {queryParams: { type: 'error' }});
                return Observable.of(false);
            });
        } else {
            return true;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/auth.guard.ts